import { Component, Input, OnInit, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { SectoresService } from '../services/sectores.service';
import { IAnalisisItem } from '../interfaces/sector.interface';
import { SessionService } from '@shared/helpers/sesion.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-analisis',
  templateUrl: './analisis.component.html',
  providers: [MessageService]
})
export class AnalisisComponent implements OnInit, OnChanges {
  @Input() sector: string = '';
  @Input() descripcion: string = '';
  @Input() visible: boolean = false;

  @ViewChild('dt') table!: Table;
  
  dataSource: IAnalisisItem[] = [];
  loading: boolean = false;
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  displayedColumns = [
    { field: 'iVariable', header: 'Variable', sortable: true },
    { field: 'sDescripcion', header: 'Descripción', sortable: true },
    { field: 'numero_relacion', header: 'Relación', sortable: true },
    { field: 'tipo', header: 'Tipo', sortable: true },
    { field: 'descripcion', header: 'Descripción', sortable: true },
    { field: 'actions', header: 'Acciones', sortable: false }
  ];

  constructor(
    private messageService: MessageService,
    private sectoresService: SectoresService,
    private sessionService: SessionService
  ) {}

  ngOnInit(): void {
    // No cargar datos automáticamente al inicializar
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Solo cargar datos cuando el componente se vuelve visible y tiene un sector válido
    if (changes['visible'] && changes['visible'].currentValue === true && this.sector) {
      this.loadData();
    }
  }

  loadData(): void {
    this.loading = true;
    
    const request = {
      sUsuario: this.sessionService.getUserSession() || '',
      iAccion: 4,
      sSector: this.sector,
      iVariable: 0,
      sDescripcion: '',
      iNumRel: 0
    };

    this.sectoresService.getAnalisis(request).subscribe({
      next: (response) => {
        if (response.success) {
          this.dataSource = response.data;
          this.totalRecords = response.data.length;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Error al cargar los datos de análisis'
          });
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al cargar análisis:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar los datos de análisis'
        });
        this.loading = false;
      }
    });
  }

  onPage(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
    this.loadData();
  }

  displayDialog: boolean = false;
  selectedAnalisis: IAnalisisItem | null = null;

  openNew(): void {
    this.selectedAnalisis = null;
    this.displayDialog = true;
  }

  openEdit(item: IAnalisisItem): void {
    this.selectedAnalisis = { ...item };
    this.displayDialog = true;
  }

  onDialogClosed(): void {
    this.selectedAnalisis = null;
    this.displayDialog = false;
  }

  onSave(result: { success: boolean; message: string }): void {
    if (result?.success) {
      this.messageService.add({
        severity: 'success',
        summary: 'Éxito',
        detail: result.message
      });
      this.loadData(); // Recargar la lista
    }
    this.displayDialog = false;
  }

  openDelete(item: IAnalisisItem): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: `¿Está seguro de eliminar el análisis de la variable ${item.iVariable}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      iconColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        
        const request = {
          sUsuario: this.sessionService.getUserSession() || '',
          iAccion: 3,
          sSector: this.sector,
          iVariable: item.iVariable,
          sDescripcion: '',
          iNumRel: 0
        };

        this.sectoresService.deleteAnalisis(request).subscribe({
          next: (response) => {
            if (response.success && response.data) {
              this.messageService.add({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Análisis eliminado correctamente'
              });
              this.loadData(); // Recargar la lista
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al eliminar el análisis'
              });
            }
            this.loading = false;
          },
          error: (error) => {
            console.error('Error al eliminar análisis:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Error al eliminar el análisis'
            });
            this.loading = false;
          }
        });
      }
    });
  }
}
